(function () {
	'use strict';

	a3_cabin_reports.factory('FlightFactory', FlightFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FlightFactory
    * @description 
    *   Add, Update, Delete and Get Flights 
    * @ngInject
    */
	function FlightFactory($log, $filter, localStorageMD5Service, UserFactory, CabinReportLocalEditFactory, ServerCabinReportFactory, FlightCrewMemberFactory, MessageFactory, liveVersion, GenericService, SyncLogFactory) {

		var daysThatAFlightIsConsideredTooOld = -20;

        /**
        * Initialize the Flight
        * @memberof FlightFactory
        */
		function Flight() {
			this.AcTailNo = null;
			this.AcType = null;
			this.Category = null;
			this.CrewAimsId = null;
			this.Departure = null;
			this.Arrival = null;
			this.FlightAimsId = null;
			this.FlightId = null;
			this.FlightDate = null;
			this.FlightNo = null;
			this.IsDHC = null;
			this.Position = null;
			//v1.1 added pax and dep/arr details
			this.BookedC = null;
			this.BookedY = null;
			this.BookedInf = null;
			this.BookedPad = null;
			this.BookedChld = null;
			this.ActualC = null;
			this.ActualY = null;
			this.ActualInf = null;
			this.ActualPad = null;
			this.ActualChld = null;
			this.DepartureICAO = null;
			this.DepartureCountry = null;
			this.DepartureName = null;
			this.ArrivalICAO = null;
			this.ArrivalCountry = null;
			this.ArrivalName = null;

			this.ScheduledDeparture = null;
			this.Status = null;
			this.LineStatus = null;
			this.LineStatusDescr = null;
			this.LocalReportId = null;
			this.ServerReportLink = null;
			this.ScheduledDepartureDateUTC = null;
			this.ScheduledDepartureTimeUTC = null;
			this.LocalReportHasNothingToReport = false;
			this.ServerReportHasNothingToReport = false;
			this.IsLocal = false;
			this.cabinReports = [];
			this.cabinReportStatusDescr = '';
			this.crew = new Array();

			//new fields
			this.DepartureGate = null;
			this.DepartureTimezone = null;
			this.ArrivalTimezone = null;
			this.CallSign = null;
			this.ScheduledArrival = null;
			this.messages = null;
			this.assessment = null;
			this.Route = null;
			this.DutyDate = null;
			this.FlightsFilters = [];
			this.ETA = null;
			this.IsScheduleChanged = false;
			//zones
			this.Zones = [];
			//
			this.AircraftDifferences = [];
			this.GetId = GetId;
			this.getRoute = getRoute;
			this.getDescription = getDescription;
			this.getSeniorAttendantsCount = getSeniorAttendantsCount;
			//TODO REMOVE CHECK VALIDITY WITH NEW VIEW
			this.initializeCabinReportStatus = initializeCabinReportStatus;
			this.getCabinReportStatusDescr = getCabinReportStatusDescr;
			this.getServerCabinReportForUser = getServerCabinReportForUser;
			this.getServerCabinReportsByAnotherUser = getServerCabinReportsByAnotherUser;
			this.initialize = initialize;
		}

		var service =
		{
			getFlightsFromStorage: getFlightsFromStorage,
			getFlightFromTotalFlights: getFlightFromTotalFlights,
			fromObject: fromObject,
			fromObjectList: fromObjectList,
			getFlightsFromStorageAndCheckIfTooOld: getFlightsFromStorageAndCheckIfTooOld,
			setFlightsToStorage: setFlightsToStorage,
			storeFlightsWithReportsAndMessages: storeFlightsWithReportsAndMessages,
			getFlightFromStorage: getFlightFromStorage,
			getFlightsByRoute: getFlightsByRoute,
			getLocalFlightFromStorage: getLocalFlightFromStorage,
			createLocalFlight: createLocalFlight,
			saveLocalFlight: saveLocalFlight,
			getLocalFlightsAndMergeWithServerFlights: getLocalFlightsAndMergeWithServerFlights,
			updateFlightFromReport: updateFlightFromReport,
			updateFlight: updateFlight,
			mergeFlightInfo: mergeFlightInfo,
			markScheduleChangedFlights: markScheduleChangedFlights,
			initializeFlights: initializeFlights,
			getFlightsByDutyNo:getFlightsByDutyNo,
			getFlightsWithStoredReport: getFlightsWithStoredReport,
			getFlightsByFlightId: getFlightsByFlightId,
			insertFlightsWithPendingTrainings: insertFlightsWithPendingTrainings,
			getTheFirstAndTheLastFlightDates: getTheFirstAndTheLastFlightDates
		};

		var objType = 'flights';
		var objCallback = Flight;

		//Object Functions
        /**
         * Overide default get Id
         * @memberof FlightFactory
         * @returns {number} Id 
         */
		function GetId() {
			return this.FlightId;
		}
        /**
         * Get flight's Route
         * @memberof FlightFactory
         * @returns {string} route 
         */
		function getRoute() {
			if (this.Departure == null && this.Arrival == null) return '-null-';
			else return (this.Departure || '?') + '-' + (this.Arrival || '?');
		}
        /**
         * Get flight's description
         * @memberof FlightFactory
         * @returns {string} description 
         */
		function getDescription() {
			if (this.FlightNo == null && this.Departure == null && this.Arrival == null) return '-null-';
			else return (this.ScheduledDepartureDateUTC || '?') + ' ' + (this.FlightNo || '?') + ' ' + (this.Departure || '?') + '-' + (this.Arrival || '?');
		}
        /**
         * Get flight's Senior Attendants Count
         * @memberof FlightFactory
         * @returns {number} seniorAttendantsCount 
         */
		function getSeniorAttendantsCount() {
			if (this.crew == null || this.crew.length == 0) return 0;
			var count = 0;
			var attendants = $filter('filter')(this.crew, {
				position: 'SA',
				isDHC: false
			});
			if (attendants != null) count = attendants.length;
			return count;
		}

		function insertFlightsWithPendingTrainings(flightsWithPendings){
			if(flightsWithPendings){
				var flights = getFlightsFromStorage();
				var flightIdsLS = flights.map(x=>x.FlightId);
				var flightsToInsert = flightsWithPendings.filter(f=> !flightIdsLS.includes(f.FlightId));
				var updatedFlightList = flights.concat(flightsToInsert);
				setFlightsToStorage(updatedFlightList);
			}
        }

        /**
         * Initialize Cabin report Status
         * @memberof FlightFactory
         */
		function initializeCabinReportStatus() {
			// load the user
			var user = UserFactory.getUser();

			//Cannot file a report when a problem with the user or if the
			//person is DHC on that flight
			if (user == null || this.IsDHC != 0) {
				this.LineStatus = "na";
				return;
			}
			//not an SA? Normally not allowed to file a report
			//UNLESS there is no SA on board
			else if (this.Position != 'SA' && this.getSeniorAttendantsCount() > 0 && this.AcType != "AT4") {
				//console.debug('FA with ' + this.getSeniorAttendantsCount() + ' SA(s) on board!');
				this.LineStatus = "na";
				return;
			}

			// initialize to pending
			this.LineStatus = "pending";

			// check if there is a local edit report or a server report for this
			// flight
			var serverReportForThisUser = this.getServerCabinReportForUser(user.aimsId);
			var serverReportsByAnotherUser = this.getServerCabinReportsByAnotherUser(user.aimsId);

			var hasServerReportForThisUser = serverReportForThisUser != null;
			var hasServerReportsByAnotherUser = serverReportsByAnotherUser.length > 0;

			var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(this.FlightId);

			this.LocalReportId = null;
			this.ServerReportLink = null;

			// if there is a local copy of the report
			if (localReport != null) {
				this.LocalReportId = localReport.ReportGuid;
				this.LocalReportHasNothingToReport = localReport.NothingToReport;

				if (localReport.Status === 'draft') {
					if (hasServerReportsByAnotherUser)
						this.LineStatus = "draftotheruser";
					else
						this.LineStatus = "draft";
				} else if (localReport.Status === 'completed') {
					if (hasServerReportsByAnotherUser)
						this.LineStatus = "completedotheruser";
					else
						this.LineStatus = "completed";
				} else if (localReport.Status === 'synched') {
					if (hasServerReportsByAnotherUser)
						this.LineStatus = "synchedotheruser";
					else
						this.LineStatus = "synched";
				} else {
					if (hasServerReportsByAnotherUser)
						this.LineStatus = "draftotheruser";
					else
						this.LineStatus = "draft";
				}
			} else {
				// if there is a server report by this and by another user
				if (hasServerReportForThisUser && hasServerReportsByAnotherUser) {
					this.LineStatus = "stored+otheruser";
					// Something if this or any other user has something to
					// report
					this.ServerReportHasNothingToReport = serverReportForThisUser.ReportedItems == 0;
					if (this.ServerReportHasNothingToReport) {
						// if nothing to report by this user, check if any other
						// user has something to report
						for (var i = 0; i < serverReportsByAnotherUser.length; i++) {
							if (serverReportsByAnotherUser[i].ReportedItems > 0) {
								this.ServerReportHasNothingToReport = false;
								break;
							}
						}
					}
				}
				// if there is a server report for another user
				else if (hasServerReportsByAnotherUser) {
					this.LineStatus = "storedotheruser";

					this.ServerReportHasNothingToReport = true;
					for (var i = 0; i < serverReportsByAnotherUser.length; i++) {
						if (serverReportsByAnotherUser[i].ReportedItems > 0) {
							this.ServerReportHasNothingToReport = false;
							break;
						}
					}
				}
				// if there is a server report for only this user
				else if (hasServerReportForThisUser) {
					this.LineStatus = "stored";
					this.ServerReportHasNothingToReport = serverReportForThisUser.ReportedItems == 0;
				}
				// no server report
				else {
					this.LocalReportId = "new";

					// no server report found for this user, status is pending
					if (new Date(this.ScheduledDeparture) < new Date()) {
						this.LineStatus = "pendingoverdue";
					} else {
						this.LineStatus = "pending";
					}
				}

			}
		}

        /**
         * Get Cabin Report Status Descr
         * @memberof FlightFactory
         * @returns {string} description 
         */
		function getCabinReportStatusDescr() {
			if (this.LineStatus === 'na')
				return "n/a";
			else if (this.LineStatus === 'pending')
				return "Pending";
			else if (this.LineStatus === 'pendingoverdue')
				return "Pending";
			else if (this.LineStatus === 'draft')
				return "Draft";
			else if (this.LineStatus === 'completed')
				return "Completed";
			else if (this.LineStatus === 'synched')
				return "Synched";
			else if (this.LineStatus === 'draftotheruser')
				return "Draft +";
			else if (this.LineStatus === 'completedotheruser')
				return "Completed +";
			else if (this.LineStatus === 'synchedotheruser')
				return "Synched +";
			else if (this.LineStatus === 'stored')
				return "Stored";
			else if (this.LineStatus === 'storedotheruser')
				return "Stored";
			else if (this.LineStatus === 'stored+otheruser')
				return "Stored +";
			else
				return this.LineStatus;
		}

        /**
         * Get Server CabinReport For the selected User
         * @memberof FlightFactory
         * @param {number} userAimsId The user aims Id
         * @return {object} cabinReport 
         */
		function getServerCabinReportForUser(userAimsId) {

			if (this.cabinReports == null)
				return null;

			var result = null;

			for (var i = 0; i < this.cabinReports.length; i++) {
				if (this.cabinReports[i] != null) {
					if (this.cabinReports[i].AuthorAimsId == userAimsId) {
						result = this.cabinReports[i];
						break;
					}
				}
			}

			return result;
		}

        /**
         * Get Server CabinReport For others than the selected User
         * @memberof FlightFactory
         * @param {number} userAimsId The user aims Id
         * @return {object} cabinReport 
         */
		function getServerCabinReportsByAnotherUser(userAimsId) {

			if (this.cabinReports == null)
				return new Array();

			var result = new Array();

			for (var i = 0; i < this.cabinReports.length; i++) {
				if (this.cabinReports[i] != null) {
					if (this.cabinReports[i].AuthorAimsId != userAimsId) {
						result.push(this.cabinReports[i]);
					}
				}
			}

			return result;
		}


        /**
         * Initialize Cabin Report
         * @memberof FlightFactory
         */
		function initialize() {
			try {
				// SD date/time
				if (this.ScheduledDeparture != null) {
					var STD = this.ScheduledDeparture;
					if (STD.indexOf('Z') < 0)
						STD += 'Z';
					STD = new moment(STD);
					STD = new Date(STD);
					STD = STD.toUTC();
					this.ScheduledDepartureDateUTC = STD.toString('yyyy-MM-dd');
					this.ScheduledDepartureTimeUTC = STD.toString('HH:mm');
				}

				// initialize the cabin report status field
				this.initializeCabinReportStatus();

				// initialize css classes for display
				this.cabinReportStatusDescr = this.getCabinReportStatusDescr();
			} catch (ex) {
				$log.error("initialize failed: " + ex.message);
			}
		}

		//Factory Functions

        /**
         * Extend Object from the default Flight Object
         * @memberof FlightFactory
         * @param {Object} obj  a Flight
         * @returns {Object} Flight
         */
		function fromObject(obj) {
			if (obj == null) return null;
			var flight = new Flight();
			angular.extend(flight, obj);

			if (obj.crew == null)
				obj.crew = [];

			flight.crew = new Array();
			for (var j = 0; j < obj.crew.length; j++) {
				flight.crew.push(FlightCrewMemberFactory.fromObject(obj.crew[j]));
			}

			return flight;
		};

        /**
         * Extend an array of Objects from the default flight Object
         * @memberof FlightFactory
         * @param {Array} objList  an Array Of flights
         * @returns {Array} flights
         */
		function fromObjectList(objList) {
			if (objList == null) return [];

			var arrayLength = objList.length;
			var flights = new Array();

			for (var i = 0; i < arrayLength; i++) {
				var flight = new Flight();
				angular.extend(flight, objList[i]);

				if (objList[i].crew == null)
					objList[i].crew = [];


				flights.push(flight);
			}

			return flights;
		};

        /**
         * Returns all the flights from storage
         * @memberof FlightFactory
         * @returns {Array} flights
         */
		function getFlightsFromStorage() {
			var objects = localStorageMD5Service.get(objType);
			return fromObjectList(objects);
		}

		/**
		* Returns the flights from local storage only if they are recent
		* @memberof FlightFactory
		* @returns {Array} flights
		*/
		function getFlightsFromStorageAndCheckIfTooOld() {
			var result = getFlightsFromStorage();

			if (result == null)
				return null;

			var dataIsRecent = false;
			var arrayLength = result.length;

			// loop all flights and break if a flight in the last 10 days is found
			for (var i = 0; i < arrayLength; i++) {
				if (Date.today().add(daysThatAFlightIsConsideredTooOld).days().toUTC().isBefore(new Date(result[i].ScheduledDeparture).toUTC().trimTime())) {
					dataIsRecent = true;
					break;
				}
			}

			if (dataIsRecent == true || (!liveVersion))
				return result;
			else
				return null;
		}

        /**
         * Set flights to  storage
         * @memberof FlightFactory
         * @returns {Array} flights
         */
		function setFlightsToStorage(flights) {
			for (var i = 0; i < flights.length; i++) {
				if (flights[i].FlightId == undefined || flights[i].FlightId == null) {
					flights[i].FlightId = guid();
				}
			}
			localStorageMD5Service.set('flights', flights);
		}

        /**
         * Initialize flights and save them
         * @memberof FlightFactory
         */
		function initializeFlights() {
			var objList = localStorageMD5Service.get(objType);
			if (objList == null) return null;

			var arrayLength = objList.length;
			var flights = new Array();

			for (var i = 0; i < arrayLength; i++) {
				var flight = new Flight();
				angular.extend(flight, objList[i]);

				if (objList[i].crew == null)
					objList[i].crew = [];

				flight.crew = new Array();
				for (var j = 0; j < objList[i].crew.length; j++) {
					flight.crew.push(FlightCrewMemberFactory.fromObject(objList[i].crew[j]));
				}

				flight.initialize();
				flights.push(flight);
			}


			localStorageMD5Service.set('flights', flights);
		}

		/**
		* Store Flights With Reports And Messages
		* @memberof FlightFactory
		* @param {Array} flights 
		* @param {Array} cabinReports
		* @param {Array} messages
		*/
		function storeFlightsWithReportsAndMessages(flights, cabinReports, messages) {

			var flightsX = fromObjectList(flights);
			var cabinReportsX = ServerCabinReportFactory.fromObjectList(cabinReports);
			var messagesX = MessageFactory.fromObjectList(messages);

			if (flightsX && flightsX instanceof Array && flightsX.length > 0 && (cabinReportsX || messagesX)) {

				// loop all flights
				var user = UserFactory.getUser();
				var f, pr, me;
				for (var fi = 0; fi < flightsX.length; fi++) {

					f = flightsX[fi];

					// find cabin reports for this flight
					f.cabinReports = [];
					f.messages = [];

					if (cabinReportsX && cabinReportsX instanceof Array && cabinReportsX.length > 0) {

						for (var pri = 0; pri < cabinReportsX.length; pri++) {

							pr = cabinReportsX[pri];
							if (pr.FlightId != null && pr.FlightId == f.FlightId) {

								if (pr.AuthorAimsId == f.CrewAimsId) {
									pr.Source = ServerCabinReportFactory.constSourceStoredOwn;
									f.cabinReports.push(pr);
								} else {
									pr.Source = ServerCabinReportFactory.constSourceStoredOther;
									f.cabinReports.push(pr);
								}
							}
						}
					}

					if (messagesX && messagesX instanceof Array && messagesX.length > 0) {

						for (var mi = 0; mi < messagesX.length; mi++) {
                            me = messagesX[mi];
                            var vf =  moment.utc(me.ValidFrom);
                            var vt =  moment.utc(me.ValidTo);
                            if(moment.utc(f.FlightDate).isBetween(vf,vt,undefined,'[]')){
                                if (me.QueryType.trim() == 'Country' && (me.Country.trim() == f.ArrivalCountry || me.Country.trim() == f.DepartureCountry)) {
                                    f.messages.push(me.Id);
                                } else if (me.QueryType.trim() == 'FlightNo' && me.FlightNo == f.FlightNo) {
                                    f.messages.push(me.Id);
                                } else if (me.QueryType.trim() == 'Airports') {
                                    if (me.FlightDirection == 'DEP' && me.AirportA == f.Departure && me.AirportB == f.Arrival) {
                                        f.messages.push(me.Id);
                                    } else if (me.FlightDirection == 'ARR' && me.AirportB == f.Departure && me.AirportA == f.Arrival) {
                                        f.messages.push(me.Id);
                                    } else if (me.FlightDirection == 'ANY' && ((me.AirportA == f.Departure && me.AirportB == f.Arrival) || (me.AirportB == f.Departure && me.AirportA == f.Arrival))) {
                                        f.messages.push(me.Id);
                                    }

                                } else if (me.QueryType.trim() == 'Airport') {
                                    if (me.FlightDirection == 'DEP' && me.AirportA == f.Departure) {
                                        f.messages.push(me.Id);
                                    } else if (me.FlightDirection == 'ARR' && me.AirportA == f.Arrival) {
                                        f.messages.push(me.Id);
                                    } else if (me.FlightDirection == 'ANY' && ((me.AirportA == f.Departure) || (me.AirportA == f.Arrival))) {
                                        f.messages.push(me.Id);
                                    }
                                } else if (me.QueryType.trim() == 'Registration' && f.AcTailNo == me.Registration) {
                                    f.messages.push(me.Id);
                                } else if (me.QueryType.trim() == 'AcType' && f.AcType == me.AcType) {
                                    f.messages.push(me.Id);
                                }
                            }
						}
					}

					f.initialize();
				}
			}
			localStorageMD5Service.set('flights', flightsX);
		}

        /**
         * Get Flight from local and storage flights
         * @memberof FlightFactory
         * @param {number} flightId 
         * @return {object} flight
         */
		function getFlightFromTotalFlights(flightId) {
			var flight = getFlightFromStorage(flightId);

			if (!flight) {
				flight = getLocalFlightFromStorage(flightId);
			}

			return flight;
		}

        /**
         * Get Flight from storage flights
         * @memberof FlightFactory
         * @param {number} flightId 
         * @return {object} flight
         */
		function getFlightFromStorage(flightId) {
			var objects = localStorageMD5Service.get(objType);
			if (objects == null)
				return null;

			var result = null;

			var arrayLength = objects.length;
			for (var i = 0; i < arrayLength; i++) {
				if (objects[i].FlightId == flightId) {
					result = objects[i];
					break;
				}
			}

			return fromObject(result);
		}

        /**
         * Get the Flights of the selected route
         * @memberof FlightFactory
         * @param {string} Route 
         * @param {string} DutyDate 
         * @return {array} flights
         */
		function getFlightsByRoute(Route, DutyDate) {
			var flights = getFlightsFromStorage();
			if (flights == null)
				return [];

			var result = [];

			var arrayLength = flights.length;
			for (var i = 0; i < arrayLength; i++) {
				if (flights[i].Route == Route && flights[i].DutyDate == DutyDate) {
					result.push(flights[i]);
				}
			}

			return result;
		}

		/**
		* create a local flight (Add flight button on main screen)
		* @memberof FlightFactory
		* @param {string} datetime 
		* @param {string} number 
		* @param {string} departure 
		* @param {string} destination 
		* @param {string} regno 
		* @param {string} actype 
		* @return {object} flight
		*/
		function createLocalFlight(datetime, number, departure, destination, regno, actype) {

			var user = UserFactory.getUser();

			if (user == null)
				return null;

			var result = new Flight();
			result.AcTailNo = regno;
			result.AcType = actype;
			result.Category = '-';
			result.CrewAimsId = user.aimsId;
			result.Departure = departure;
			result.Arrival = destination;
			result.FlightAimsId = guid();
			result.FlightId = guid();
			result.FlightDate = datetime.toString('yyyy-MM-dd') + 'T' + datetime.toString('HH:mm:ss');;
			result.FlightNo = number;
			result.IsDHC = 0;
			result.Position = user.position;
			result.ScheduledDeparture = datetime.toString('yyyy-MM-dd') + 'T' + datetime.toString('HH:mm:ss');
			result.Status = 'OK';
			result.IsLocal = true;
			result.initialize();

			return result;
		}

        /**
         * Save a local flight
         * @memberof FlightFactory
         * @param {object} flight
         */
		function saveLocalFlight(flight) {

			// get the local flights array from storage
			var localFlights = fromObjectList(localStorageMD5Service.get('localFlights'));
			if (localFlights == null)
				localFlights = new Array();

			// find the current flight in the array (if present)
			var arrayLength = localFlights.length;
			var flightIndex = -1;
			for (var i = 0; i < arrayLength; i++) {
				if (localFlights[i].FlightId != null && localFlights[i].FlightId == flight.FlightId) {
					flightIndex = i;
					break;
				}
			}

			// add or update a copy of the current report
			if (flightIndex >= 0)
				localFlights[flightIndex] = flight;
			else
				localFlights.push(flight);

			// save
			localStorageMD5Service.set('localFlights', localFlights);
		}

        /**
         * merges the given flights with the stored local flights
         * @memberof FlightFactory
         * @param {array} serverFlights 
         * @return {array} flights
         */
		function getLocalFlightsAndMergeWithServerFlights(serverFlights) {

			if (serverFlights == null)
				serverFlights = [];

			// get the local flights array from storage
			var localFlights = fromObjectList(localStorageMD5Service.get('localFlights'));
			if (localFlights == null)
				localFlights = [];

			// add the local flight to the given array
			var arrayLength = localFlights.length;
			for (var i = 0; i < arrayLength; i++) {
				localFlights[i].initialize();
				serverFlights.push(localFlights[i]);
			}


			return serverFlights;
		}
        /**
         * Get Flight from local flights
         * @memberof FlightFactory
         * @param {number} flightId 
         * @return {object} flight
         */
		function getLocalFlightFromStorage(flightId) {
			var flight = GenericService.get(flightId, 'localFlights', objCallback);
			if (flight) {
				flight.initialize();
			}
			return fromObject(flight);
		}
        /**
         * Update Flight from report
         * @memberof FlightFactory
         * @param {object} report 
         */
		function updateFlightFromReport(report) {
			var flight = getFlightFromStorage(report.FlightId);
			if (flight != null && flight != undefined) {
				var reportIndex;
				flight.AcTailNo = report.AcTailNo;
				flight.AcType = report.AcType;

				var allflights = getFlightsFromStorage();
				for (var i = 0; i < allflights.length; i++) {
					if (allflights[i].FlightId != null && allflights[i].FlightId == report.FlightId) {
						reportIndex = i;
						break;
					}
				}

				flight.initialize();
				allflights[reportIndex] = flight;
				setFlightsToStorage(allflights);
			}
		}


        /**
         * Update Flight 
         * @memberof FlightFactory
         * @param {object} flight 
         */
		function updateFlight(flight) {

			// get the  flights array from storage
			var flights = getFlightsFromStorage();

			// find the current flight in the array (if present)
			var arrayLength = flights.length;
			var flightIndex = -1;
			for (var i = 0; i < arrayLength; i++) {
				if (flights[i].FlightId != null && flights[i].FlightId == flight.FlightId) {
					flightIndex = i;
					break;
				}
			}

			//Add or update a copy of the current report
			if (flightIndex >= 0)
				flights[flightIndex] = flight;
			else
				flights.push(flight);

			//Save
			localStorageMD5Service.set('flights', flights);
		}

        /**
         * mark Schedule Changed Flights by comparing flights from new and old data
         * @memberof FlightFactory
         * @param {object} newFlights 
         * @param {object} oldFlights
         * @return {object} newFlights 
         */
		function markScheduleChangedFlights(newFlights, oldFlights) {
			var lastScheduleDate = SyncLogFactory.getLastScheduleDate();

			//if there are no old flights  or no last schedule date
			if (oldFlights && lastScheduleDate) {
				//loop all new flights
				var exists;
				for (var i = 0; i < newFlights.length; i++) {
					//loop all old flights
					exists = false;
					for (var j = 0; j < oldFlights.length; j++) {
						if (newFlights[i].FlightNo == oldFlights[j].FlightNo && newFlights[i].FlightNo == oldFlights[j].FlightNo && newFlights[i].FlightDate == oldFlights[j].FlightDate && newFlights[i].Departure == oldFlights[j].Departure) {
							exists = true;
							break;
						}
					}
					//check if flight is newly added and is before the last schedule date
					var flightDate = new Date(newFlights[i].FlightDate);
					if (!exists && flightDate.getTime() <= lastScheduleDate) {
						newFlights[i].IsScheduleChanged = true;
					}
				}
			}

			return newFlights;
		}

		//factory functions
        /**
         * Update Passenger information
         * @memberof FlightFactory
         * @param {object} flightInfo  The flight informations 
         */
		function mergeFlightInfo(flightInfo, showPaxNames) {
			if (flightInfo) {
				var currentFlightInfo = GenericService.get(flightInfo.FlightId, objType, objCallback);

				currentFlightInfo.CrewAimsId = flightInfo.CrewAimsId;
				currentFlightInfo.DutyDate = flightInfo.DutyDate;
				currentFlightInfo.Route = flightInfo.Route;
				currentFlightInfo.FlightId = flightInfo.FlightId;
				currentFlightInfo.FlightAimsId = flightInfo.FlightAimsId;
				currentFlightInfo.FlightDate = flightInfo.FlightDate;
				currentFlightInfo.FlightNo = flightInfo.FlightNo;
				currentFlightInfo.Departure = flightInfo.Departure;
				currentFlightInfo.Arrival = flightInfo.Arrival;
				currentFlightInfo.AcType = flightInfo.AcType;
				currentFlightInfo.AcTailNo = flightInfo.AcTailNo;
				currentFlightInfo.ScheduledDeparture = flightInfo.ScheduledDeparture;
				currentFlightInfo.ScheduledArrival = flightInfo.ScheduledArrival;
				currentFlightInfo.BookedC = flightInfo.BookedC;
				currentFlightInfo.BookedY = flightInfo.BookedY;
				currentFlightInfo.BookedInf = flightInfo.BookedInf;
				currentFlightInfo.BookedPad = flightInfo.BookedPad;
				currentFlightInfo.BookedChld = flightInfo.BookedChld;
				currentFlightInfo.ActualC = flightInfo.ActualC;
				currentFlightInfo.ActualY = flightInfo.ActualY;
				currentFlightInfo.ActualInf = flightInfo.ActualInf;
				currentFlightInfo.ActualPad = flightInfo.ActualPad;
				currentFlightInfo.ActualChld = flightInfo.ActualChld;
				currentFlightInfo.Category = flightInfo.Category;
				currentFlightInfo.Status = flightInfo.Status;
				currentFlightInfo.Position = flightInfo.Position;
				currentFlightInfo.IsDHC = flightInfo.IsDHC;
				currentFlightInfo.CallSign = flightInfo.CallSign;
				currentFlightInfo.DepartureGate = flightInfo.DepartureGate;
				currentFlightInfo.DepartureStand = flightInfo.DepartureStand;
                currentFlightInfo.ArrivalStand = flightInfo.ArrivalStand;
				currentFlightInfo.DepartureICAO = flightInfo.DepartureICAO;
				currentFlightInfo.DepartureName = flightInfo.DepartureName;
				currentFlightInfo.DepartureCountry = flightInfo.DepartureCountry;
				currentFlightInfo.ArrivalICAO = flightInfo.ArrivalICAO;
				currentFlightInfo.ArrivalName = flightInfo.ArrivalName;
				currentFlightInfo.ArrivalCountry = flightInfo.ArrivalCountry;
				currentFlightInfo.DepartureTimezone = flightInfo.DepartureTimezone;
				currentFlightInfo.ArrivalTimezone = flightInfo.ArrivalTimezone;
				currentFlightInfo.DepartureSchengen = flightInfo.DepartureSchengen;
				currentFlightInfo.ArrivalSchengen = flightInfo.ArrivalSchengen;
				currentFlightInfo.DepartureEU = flightInfo.DepartureEU;
				currentFlightInfo.ArrivalEU = flightInfo.ArrivalEU;
				currentFlightInfo.ETD = flightInfo.ETD;
				currentFlightInfo.ATD = flightInfo.ATD;
				currentFlightInfo.ETA = flightInfo.ETA;
				currentFlightInfo.ATA = flightInfo.ATA;
				currentFlightInfo.CTOT = flightInfo.CTOT;
				currentFlightInfo.DepartureCountryISO = flightInfo.DepartureCountryISO;
				currentFlightInfo.ArrivalCountryISO = flightInfo.ArrivalCountryISO;
				currentFlightInfo.crew = flightInfo.crew;
				currentFlightInfo.Zones = flightInfo.Zones;
				currentFlightInfo.showPaxNames = showPaxNames;

				GenericService.save(currentFlightInfo,objType,objCallback);
			}
		}

		/**
         * Get Flights of a Crew Route
         * @memberof FlightFactory
         * @param {number} dutyNo 
         * @param {string} dutyDay
		 * @return {array} flights
         */
		function getFlightsByDutyNo(dutyNo, dutyDay){
			var flights = getFlightsFromStorage();
			if (flights == null)
				return [];
			var result = [];
			var arrayLength = flights.length;
			for (var i = 0; i < arrayLength; i++) {
				if (flights[i].DutyNo == dutyNo && flights[i].DutyDay == dutyDay) {
					result.push(flights[i]);
				}
			}
			return result;
		}

		/**
         * Get Flights of a Crew Route using a flightId
         * @memberof FlightFactory
         * @param {number} flightId 
		 * @return {array} flights
         */
        function getFlightsByFlightId(flightId){
            var result = [];
            var flight = getFlightFromStorage(flightId);
            var flights = getFlightsFromStorage();
            if (flight != null){
                for (var i = 0; i < flights.length; i++) {
                    if (flights[i].DutyNo == flight.DutyNo && flights[i].DutyDay == flight.DutyDay) {
                        result.push(flights[i]);
                    }
                }
            }
            return result;
        }

		
		
		/**
         * Get Flights with report status "Stored"
         * @memberof FlightFactory
		 * @return {array} flights
         */
		function getFlightsWithStoredReport(){
			var flights = getFlightsFromStorage();
			if (flights == null)
				return [];
			var result = [];
			var arrayLength = flights.length;
			for (var i = 0; i < arrayLength; i++) {
				if (flights[i].cabinReportStatusDescr == "Stored") {
					result.push(flights[i]);
				}
			}
			return result;
		}

		function getTheFirstAndTheLastFlightDates(){
			const flights = getFlightsFromStorage();

			const parseDate = dateString => new Date(dateString);

			let firstFlightDate = null;
			let lastFlightDate = null;

			for (const obj of flights) {
				//const currentDate = new Date(obj.FlightDate);
				const currentDate = parseDate(obj.FlightDate);

				if (!firstFlightDate || currentDate < firstFlightDate) {
					firstFlightDate = currentDate;
				}

				if (!lastFlightDate || currentDate > lastFlightDate) {
					lastFlightDate = currentDate;
				}
			}
			return {firstDate: firstFlightDate, lastDate: lastFlightDate };

		}

		return service;
	}

})();